var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeOne2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7726 40.3322C53.7364 40.0317 53.5403 39.7965 53.2949 39.634C53.2949 39.634 45.5005 35.134 45.5005 35.134C45.1909 34.9553 44.8101 34.9553 44.5005 35.134L36.7061 39.634C36.4014 39.824 36.216 40.1401 36.2061 40.5003C36.2061 40.5002 36.2061 49.5002 36.2061 49.5002C36.2061 49.8577 36.3965 50.1877 36.7061 50.3665L44.5005 54.8665C44.8173 55.0348 45.1837 55.0378 45.5005 54.8664C45.5005 54.8665 53.2949 50.3665 53.2949 50.3665C53.6045 50.1877 53.7949 49.8577 53.7949 49.5002V40.5002C53.7887 40.4438 53.7812 40.3887 53.7726 40.3322ZM45.0005 37.155L50.7949 40.5001L45.0005 43.8455L39.2061 40.5001L45.0005 37.155ZM38.2061 42.2325L44.0005 45.5778V52.2682L38.2061 48.9231V42.2325ZM46.0005 52.2682V45.5778L51.7949 42.2325V48.9231L46.0005 52.2682Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8288 26.6578C42.5065 27.7789 44.2048 26.7833 43.5514 25.6412C37.4303 15.2662 26.8205 4.40783 26.714 4.29895C26.338 3.91614 25.6623 3.91565 25.2863 4.29944C24.4171 5.18469 4.00016 26.1276 4.00016 37.9996C3.79902 52.2332 18.0217 63.0975 31.6971 59.2558C32.9608 58.9036 32.4484 56.9974 31.1832 57.3234C18.7503 60.8132 5.81687 50.9438 6.00034 37.9995C6.00016 28.1237 22.3537 10.297 26.0006 6.44495C28.4665 9.04749 36.7458 18.0421 41.8288 26.6578Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30C36.729 30 30 36.729 30 45C30.824 64.8995 59.179 64.8937 60 44.9999C60 36.729 53.271 30 45 30ZM45 58C37.8315 58 32 52.1685 32 45C32.7138 27.7537 57.2889 27.7587 58 45.0001C58 52.1685 52.1684 58 45 58Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeOne2);
export default __webpack_public_path__ + "static/media/badge_one_2.5fdb5e388d7f8297f82bb80b42f5088e.svg";
export { ForwardRef as ReactComponent };